<template>
  <div id="nav-menu">
    <div
      class="firm-name row-center"
      style="justify-content: flex-start; padding-left: 44rem"
    >
      <!-- <span>{{ $store.state.firm.firm.firmName }}</span> -->
      <span>{{ KJallName }}</span>
    </div>
    <el-menu router unique-opened :default-active="current" background-color="#ffffff" text-color="#333333"
        active-text-color="#0D94FF" v-if="HomeLogin == 1">
        <template v-for="(item, index) in filterMenu">
            <el-submenu v-if="item.list.length !== 0" :index="'' + index" :key="index">
                <template slot="title">
                    <i :class="item.icon" v-if="item.icon"></i>
                    <span>{{ item.title }}</span>
                </template>
                <el-menu-item-group v-if="item.list">
                  <template v-for="(sub, subIndex) in item.list" >
                      <el-menu-item @click="setNav(item.title + '/' + sub.title)" 
                          :key="subIndex" :index="sub.path" >{{ sub.title }}</el-menu-item>
                      <el-menu-item  v-if="sub.list&&sub.list.length>0"  @click="setNav(item.title + '/' + sub.title)"  v-for="(elm, elmIndex) in sub.list"
                          :key="elmIndex" :index="elm.path" class="twotitle">{{ elm.title }}</el-menu-item>
                  </template>
                  
                </el-menu-item-group>
            </el-submenu>

            <el-menu-item v-else :key="index" :index="item.path" @click="setNav(item.title)">
                <i :class="item.icon" v-if="item.icon"></i>
                <span slot="title">{{ item.title }}</span>
            </el-menu-item>
        </template>
    </el-menu>
    <el-menu
      v-else-if="HomeLogin == 2"
      router
      unique-opened
      :default-active="current"
      background-color="#ffffff"
      text-color="#333333"
      active-text-color="#0D94FF"
    >
      <template v-for="(item, index) in Homeprop">
        <el-submenu
          v-if="item.list.length !== 0"
          :index="'' + index"
          :key="index"
        >
          <template slot="title">
            <i :class="item.icon" v-if="item.icon"></i>
            <span>{{ item.title }}</span>
          </template>
          <el-menu-item-group v-if="item.list">
            <el-menu-item
              @click="setNav(item.title + '/' + sub.title)"
              v-for="(sub, subIndex) in item.list"
              :key="subIndex"
              :index="sub.path"
              >{{ sub.title }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item
          v-else
          :key="index"
          :index="item.path"
          @click="setNav(item.title)"
        >
          <i :class="item.icon" v-if="item.icon"></i>
          <span slot="title">{{ item.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { chainIndex } from "../../api/linkindex";
export default {
  name: "NavMenu",
  data() {
    return {
      KJallName: "",
      HomeLogin: 1,
      Homeprop: [
        {
          icon: "",
          title: "成员管理",
          path: "/admin/MemberManagement",
          list: [],
        },
        {
          icon: "",
          title: "企业信息",
          path: "/admin/EnterpriseInformation",
          list: [],
        },
      ],
      menus: [
        {
          icon: "",
          title: "首页概况",
          list: [
            {
              icon: "",
              path: "/SubstationManagement",
              title: "园区总览"
            },
            {
              icon: "",
              path: "/3D/all",
              title: "三维看板",
            },
          ],
        },
        // {
        //   icon: "",
        //   title: "一次图监控",
        //   path: "/diagram",
        //   list: [],
        // },
        {
          icon: "",
          title: "能耗监测",
          list: [
            {
              icon: "",
              path: "/power-data/Classification/none",
              title: "分类能耗",
            },
            {
              icon: "",
              path: "/power-data/Suboption/none",
              title: "分项能耗",
            },
          ],
        },
        {
          icon: "",
          title: "能耗分析",
          list: [
            {
              icon: "",
              path: "/Energy/Overview/none",
              title: "能耗综览",
            },
            {
              icon: "",
              path: "/Energy/Comparison/none",
              title: "能耗对比",
            },
            {
              icon: "",
              path: "/power-data/Pinnacle/none",
              title: "同环比分析",
            },
            {
              icon: "",
              path: "/power-data/Savingplan/none",
              title: "节能计划",
            },
            {
              icon: "",
              path: "/Energy/Structure/none",
              title: "能耗结构",
            },
            {
              icon: "",
              path: "/Energy/EnergyReport/none",
              title: "综合能耗报告",
            },
          ],
        },
        {
          icon: "",
          title: "用能报表",
          path: "",
          list: [
            {
              icon: "",
              title: "综合能耗",
              path: "/power-data/Extremum/Complex",
            },
            {
              icon: "",
              title: "分项能耗",
              path: "/power-data/Extremum/Suboption",
            },
            {
              icon: "",
              title: "能耗同环比",
              path: "/power-data/Extremum/PowerTime",
            },
            {
              icon: "",
              title: "计划与实际能耗",
              path: "/power-data/Extremum/Range",
            },
            // {
            //   icon: "",
            //   path: "/power-data/Extremum/Running",
            //   title: "用电损耗",
            // },
          ],
        },
        {
          icon: "",
          title: "资产管理",
          list: [
            {
              icon: "",
              path: "/equipment-ledger",
              title: "设备台账",
            },
            {
              icon: "", 
              path: "/document-management",
              title: "文档管理",
            },
          ],
        },
        {
          icon: "",
          title: "运行环境",
          list: [
            // {
            //   icon: "",
            //   path: "/environmentalMonitoring",
            //   title: "环境监测",
            // },
            {
              icon: "",
              path: "/securityMonitoring",
              title: "安防监控",
            },
            {
              icon: "",
              path: "/communicationStatus",
              title: "通讯状态",
            },
          ],
        },
      ],
    };
  },
  computed: {
    projectId: function() {
      return this.$store.getters.projectId;
    },
    routePath() {
      return this.$route.path;
    },
    current() {
      return this.$route.path;
    },
    filterMenu() {
        return this.menus;
    },
  },
  watch: {
    routePath(n) {
      this.$root.$nav.init(this.findTitle(n, this.menus));
    },
  },
  methods: {
    //电力监测
    // 湖光保护
    BarProp() {
      if (this.projectId == 4) {
        this.$set(this.menus[2].list, 3, {
          icon: "",
          path: "/power-data/protect1/none",
          title: "弧光保护",
          list: [],
        });
        this.$set(this.menus[3].list, 1, {
          icon: "",
          title: "谐波分析",
          path: "/power-data/PowerQuality/none",
          list: [],
        });
        this.$set(this.menus[5].list, 4, {
          icon: "",
          path: "/accident/DEVICE_FAILURE",
          title: "设备异常",
          list: [],
        });
      }
    },
    parkName() {
      this.id = this.$store.state.project.currentProject.projectId;
      chainIndex.getData(this.id).then((res) => {
        this.KJallName = res.data.data.project.projectName;
      });
    },
    findTitle(path, list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].path === path) {
          return list[i].title;
        }
      }

      for (let i = 0; i < list.length; i++) {
        if (list[i].list) {
          let findTitle = this.findTitle(path, list[i].list);
          if (findTitle) {
            return list[i].title + "/" + findTitle;
          }
        }
      }

      return null;
    },
    setNav(s) {
      //console.log(s)
    },
    //初始菜单
    getSelection() {
      // debugger
      if (sessionStorage.getItem("NavformDataIdlt") == 1) {
        this.HomeLogin = sessionStorage.getItem("NavformDataIdlt");
      } else if (sessionStorage.getItem("NavformDataIdlt") == 2) {
        this.HomeLogin = sessionStorage.getItem("NavformDataIdlt");
      } else {
        if (this.$store.state.homeitem.IformId == 2) {
          this.HomeLogin = this.$store.state.homeitem.IformId;
        } else {

          this.HomeLogin = this.$store.state.homeitem.IformId;
        }
      }
    },
  },
  created() {
    this.getSelection();
    this.parkName();
  },
  mounted() {
    // console.log(this.$store.state.homeitem.IformId)
    // this.BarProp();
    this.$root.$nav.init(this.findTitle(this.routePath, this.menus));
  },
};
</script>

<style scoped lang="less">
#nav-menu .el-menu .el-menu-item-group .el-menu-item.swei{
  color: #333333 !important;
}
#nav-menu .el-menu .el-menu-item-group .el-menu-item.twotitle {
  color: #666666 !important;
  text-indent: 35rem !important;
  .el-menu-item-group__title{
    font-size: 18rem;
    color: #333333;
    padding-left: 40rem;
  }
  .el-menu-item{
    color: #666666;
    text-indent: 35rem;
  }
}


.el-menu::-webkit-scrollbar {
  display: none !important;
}

#nav-menu {
  height: 100%;
  overflow: hidden;
  /*border-right: 0.5px solid #E5E5E5;*/
  box-shadow: 0 0 5px 1px #e5e5e5;

  * {
    border-right: none !important;
  }

  .firm-name {
    width: 100%;
    height: 11.8%;
    font-size: 18rem;
    font-weight: bold;
    color: #333333;
    border-bottom: 1px solid #e5e5e5 !important;
  }

  .el-menu {
    height: 88.2%;
    overflow: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    padding: 0;
    margin: 0;

    .el-menu-item {
      padding-left: 40rem !important;
      font-size: 18rem !important;
      color: #333333;
      font-weight: bold;
      .h(65);
      line-height: 6vh;
    }

    .el-menu-item-group {
      .el-menu-item {
        padding-left: 40rem !important;
        font-size: 18rem !important;
        color: #999999 !important;
        line-height: 6vh;
        font-weight: normal;
      }

      .is-active {
        color: #0d94ff !important;
        font-weight: bold;
      }
    }
  }
}
</style>
